export default __webpack_public_path__ + "static/media/telegram_app.083c9e9b.svg";